
webpack.register(
    'components/dropdown/dropdown-container/dropdown-container',
    function() {
        return require('components/dropdown/dropdown-container/dropdown-container');
    },
    false
);
webpack.register(
    'components/dropdown/dropdown-item/dropdown-item',
    function() {
        return require('components/dropdown/dropdown-item/dropdown-item');
    },
    false
);
var stache = require('can/view/stache/stache');
module.exports = stache("<can-import from='components/dropdown/dropdown-container/dropdown-container' />\r\n<can-import from='components/dropdown/dropdown-item/dropdown-item' />\r\n\r\n<div class=\"c-comparison-summary-tabs\">\r\n    <dropdown-container {value}=\"probabilityType\" (onChange)=\"changeTab(%event)\" expand-extra-large expand-large expand-medium-up align-right>\r\n        {{#each tabs}}\r\n            <dropdown-item value=\"{{value}}\" title=\"{{title}}\"></dropdown-item>\r\n        {{/each}}\r\n    </dropdown-container>\r\n</div>");